export default __webpack_public_path__ + "static/media/oct2023-1.211a43c1.jpeg";